export const buttons = {
  sendMessage: "Send message",
  cancel: "Cancel",
  close: "Close",
};
